import { io } from "socket.io-client";

const SOCKET_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:9000";

class SocketService {
  constructor() {
    this.socket = null;
  }

  connect() {
    if (!this.socket) {
      this.socket = io(SOCKET_URL);
      console.log("Connected to WebSocket server");
    }
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  joinTask(taskId, userEmail) {
    if (this.socket) {
      this.socket.emit("task:join", { taskId, userEmail });
    }
  }

  leaveTask(taskId, userEmail) {
    if (this.socket) {
      this.socket.emit("task:leave", { taskId, userEmail });
    }
  }

  joinUser(userId) {
    if (this.socket) {
      this.socket.emit("user:join", { userId });
    }
  }

  notifyBoardUpdate(data) {
    if (this.socket) {
      this.socket.emit("board:update", data);
    }
  }

  onBoardRefresh(callback) {
    if (this.socket) {
      this.socket.on("board:refresh", callback);
    }
  }

  offBoardRefresh(callback) {
    if (this.socket) {
      this.socket.off("board:refresh", callback);
    }
  }

  onBoardColumnsRefresh(callback) {
    if (this.socket) {
      this.socket.on("board:columns_refresh", callback);
    }
  }

  offBoardColumnsRefresh(callback) {
    if (this.socket) {
      this.socket.off("board:columns_refresh", callback);
    }
  }

  onTaskWatchersUpdate(callback) {
    if (this.socket) {
      this.socket.on("task:watchers", callback);
    }
  }

  offTaskWatchersUpdate(callback) {
    if (this.socket) {
      this.socket.off("task:watchers", callback);
    }
  }

  onTaskCommentUpdate(callback) {
    if (this.socket) {
      this.socket.on("task:comment_update", callback);
    }
  }

  offTaskCommentUpdate(callback) {
    if (this.socket) {
      this.socket.off("task:comment_update", callback);
    }
  }

  onTaskAttachmentUpdate(callback) {
    if (this.socket) {
      this.socket.on("task:attachment_update", callback);
    }
  }

  offTaskAttachmentUpdate(callback) {
    if (this.socket) {
      this.socket.off("task:attachment_update", callback);
    }
  }

  onTaskPropertyUpdate(callback) {
    if (this.socket) {
      this.socket.on("task:property_update", callback);
    }
  }

  offTaskPropertyUpdate(callback) {
    if (this.socket) {
      this.socket.off("task:property_update", callback);
    }
  }

  onNotification(callback) {
    if (this.socket) {
      this.socket.on("notification:new", callback);
    }
  }

  offNotification(callback) {
    if (this.socket) {
      this.socket.off("notification:new", callback);
    }
  }

  emitTaskPropertyUpdate(taskId, userEmail, properties) {
    if (this.socket) {
      this.socket.emit("task:property_update", {
        taskId,
        userEmail,
        properties,
      });
    }
  }

  emitFieldFocus(taskId, userEmail, fieldName) {
    if (this.socket) {
      this.socket.emit("task:field_focus", { taskId, userEmail, fieldName });
    }
  }

  emitFieldBlur(taskId, userEmail, fieldName) {
    if (this.socket) {
      this.socket.emit("task:field_blur", { taskId, userEmail, fieldName });
    }
  }

  onFieldFocus(callback) {
    if (this.socket) {
      this.socket.on("task:field_focus", callback);
    }
  }

  offFieldFocus(callback) {
    if (this.socket) {
      this.socket.off("task:field_focus", callback);
    }
  }

  onFieldBlur(callback) {
    if (this.socket) {
      this.socket.on("task:field_blur", callback);
    }
  }

  offFieldBlur(callback) {
    if (this.socket) {
      this.socket.off("task:field_blur", callback);
    }
  }

  off(event, callback) {
    if (this.socket) {
      this.socket.off(event, callback);
    }
  }

  // ── Transactions real-time ────────────────────────────────────────
  joinTransactionTable(ownerId, viewerEmail, viewerId) {
    if (this.socket) {
      this.socket.emit("transactions:join", { ownerId, viewerEmail, viewerId });
    }
  }

  leaveTransactionTable(ownerId, viewerEmail) {
    if (this.socket) {
      this.socket.emit("transactions:leave", { ownerId, viewerEmail });
    }
  }

  emitTransactionRowUpdate(ownerId, row, editorEmail) {
    if (this.socket) {
      this.socket.emit("transactions:update", { ownerId, row, editorEmail });
    }
  }

  onTransactionRowUpdate(callback) {
    if (this.socket) this.socket.on("transactions:update", callback);
  }

  offTransactionRowUpdate(callback) {
    if (this.socket) this.socket.off("transactions:update", callback);
  }

  onTransactionWatchers(callback) {
    if (this.socket) this.socket.on("transactions:watchers", callback);
  }

  offTransactionWatchers(callback) {
    if (this.socket) this.socket.off("transactions:watchers", callback);
  }
}

const socketService = new SocketService();
export default socketService;
